function cleanUniformsUrl() {
  const current = new URL(window.location.href);
  if (!/\/pages\/hl-uniforms\/?$/.test(current.pathname)) return;
  let changed = false;
  ['_su_rec', '_su_rec_id'].forEach((key) => {
    if (current.searchParams.has(key)) {
      current.searchParams.delete(key);
      changed = true;
    }
  });
  if (changed) window.history.replaceState(window.history.state, '', `${current.pathname}${current.search}${current.hash}`);
}

cleanUniformsUrl();
window.addEventListener('pageshow', cleanUniformsUrl);

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
document.querySelectorAll('[data-brand-transition]').forEach((link) => link.addEventListener('click', (event) => {
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || reducedMotion) return;
  event.preventDefault();
  document.documentElement.classList.add('is-brand-leaving');
  window.setTimeout(() => { window.location.href = link.href; }, 390);
}));
